import { useState, useEffect } from "react";
import API_CONFIG from "../../../Configuration/apiConfig";
import apiClient from "../../../Configuration/apiClient";

export function useStores(fromDate, toDate, getFilterBody) {
  const [stores, setStores] = useState([]);
  const [filteredStores, setFilteredStores] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(100);
  const [loadingStores, setLoadingStores] = useState(false);

  const [redScore, setRedScore] = useState(0);
  const [availabilityScore, setAvailabilityScore] = useState(0);
  const [activationScore, setActivationScore] = useState(0);
  const [coolerScore, setCoolerScore] = useState(0);
  const [bonusScore, setBonusScore] = useState(0);
  const [totalOutlets, setTotalOutlets] = useState(0);
  const [loadingScores, setLoadingScores] = useState(false);
  const [error, setError] = useState("");

   const filterKey = JSON.stringify(getFilterBody());

  useEffect(() => {
    if (!fromDate || !toDate) {
      setRedScore(0);
      setAvailabilityScore(0);
      setActivationScore(0);
      setCoolerScore(0);
      setBonusScore(0);
      setTotalOutlets(0);
      setStores([]);
      setFilteredStores([]);
      return;
    }

    const fetchData = async () => {
      setError("");
      setLoadingScores(true);
      setLoadingStores(true);
      setStores([]);
      setFilteredStores([]);
      setSearchQuery("");

      try {
        const [fromYear, fromMonthNum, fromDay] = fromDate.split("-").map(Number);
        const [toYear, toMonthNum, toDay] = toDate.split("-").map(Number);

        const requestBody = {
          filters: getFilterBody(),
          timePeriod: {
            from: { date: fromDay, month: fromMonthNum, year: fromYear },
            to: { date: toDay, month: toMonthNum, year: toYear },
          },
        };

        const [scoresRes, storesRes] = await Promise.all([
          apiClient.post(API_CONFIG.ENDPOINTS.STORE_REPORT.SCORES, requestBody),
          apiClient.post(API_CONFIG.ENDPOINTS.STORE_REPORT.STORE_SEARCH, requestBody),
        ]);

        setRedScore(scoresRes.data.totalRedScore || 0);
        setAvailabilityScore(scoresRes.data.availabilityScore || 0);
        setActivationScore(scoresRes.data.activationScore || 0);
        setCoolerScore(scoresRes.data.coolerScore || 0);
        setBonusScore(scoresRes.data.coolerBonus || 0);
        setTotalOutlets(scoresRes.data.totalOutlets || 0);

        const sortedStores = [...(storesRes.data || [])].sort((a, b) =>
          (a.storeName || "").toLowerCase().localeCompare((b.storeName || "").toLowerCase())
        );
        setStores(sortedStores);
        setFilteredStores(sortedStores);
      } catch (err) {
        console.error("Failed to load data:", err);
        setError("Failed to load data.");
      } finally {
        setLoadingScores(false);
        setLoadingStores(false);
      }
    };

    fetchData();
  }, [fromDate, toDate, filterKey]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    const filtered = stores
      .filter((store) =>
        store.storeName?.toLowerCase().includes(query.toLowerCase())
      )
      .sort((a, b) =>
        (a.storeName || "").toLowerCase().localeCompare((b.storeName || "").toLowerCase())
      );
    setFilteredStores(filtered);
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearchQuery("");
    setFilteredStores(stores);
    setCurrentPage(1);
  };

  const displayedStores = searchQuery.trim() ? filteredStores : stores;

  return {
    stores,
    displayedStores,
    searchQuery,
    handleSearch,
    clearSearch,
    currentPage,
    setCurrentPage,
    pageSize,
    loadingStores,
    // Scores
    redScore,
    availabilityScore,
    activationScore,
    coolerScore,
    bonusScore,
    totalOutlets,
    loadingScores,
    error,
  };
}
